<template>
  <div class="api-manager-wrap mx-auto">
    <div class="card-content card-api-manager">
      <div class="title-with-add">
        <p class="card-title">API Call Manager</p>
        <p
          class="btn-add"
          @click="openModalAdd()"
        >
          <i class="fa fa-plus" /> Add
        </p>
      </div>

      <!-- List Api -->
      <div class="list-api">
        <div
          v-for="(data, index) in dummyData"
          :key="`api-${index}`"
          class="api">
          <div class="left-section">
            <div
              :class="data.method"
              class="api-method"
            >
              {{ data.method }}
            </div>
            <div class="api-name">{{ data.apiName }}</div>
            <div class="api-url ellipsis">{{ data.apiURL }}</div>
          </div>
          <div class="right-section">
            <i
              class="fa fa-pencil-square-o edit-api"
              @click="openModalAdd()"
            />
            <i class="fa fa-trash delete-api" />
          </div>
        </div>
      </div>
    </div>

    <modal-api-manager
      v-if="isOpenModalAdd"
      :id="idModalAdd"
      @close-modal="toggleModalAdd(false)"
    />
  </div>
</template>

<script>
// Mixins
import jMixModalAdd from '@/mixins/app-manager/jMixModalAdd';
// Componenets
import modalApiManager from '@/views/application-manager/detail/app-tabs/partials/modal/modalApiManager';

export default {
  components: {
    modalApiManager,
  },

  mixins: [
    jMixModalAdd,
  ],

  data() {
    return {
      idModalAdd: 'modalAdd',
      dummyData: [
        {
          method: 'post',
          apiName: 'API Name 1',
          apiURL: 'https://app.jojonomic.com/app/Task-Management/2PomMpNcDQIq3J-shaNawBN8FbXMf0XX3k-IyYPMS',
        },
        {
          method: 'get',
          apiName: 'API Name 2',
          apiURL: 'https://api.name.com',
        },
        {
          method: 'delete',
          apiName: 'API Name 3',
          apiURL: 'https://api.name.com',
        },
        {
          method: 'post',
          apiName: 'API Name 4',
          apiURL: 'https://api.name.com',
        },
        {
          method: 'post',
          apiName: 'API Name 5',
          apiURL: 'https://api.name.com',
        },
        {
          method: 'post',
          apiName: 'API Name 6',
          apiURL: 'https://api.name.com',
        },
        {
          method: 'post',
          apiName: 'API Name 7',
          apiURL: 'https://api.name.com',
        },
        {
          method: 'post',
          apiName: 'API Name 8',
          apiURL: 'https://api.name.com',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/jApiManagerTab.vue